import { useTranslation } from 'react-i18next';

/** The display label of an audit action key; an unknown key shows as itself. */
export function useAuditActionLabel(): (action: string) => string {
  const { t, i18n } = useTranslation();
  return (action) => (i18n.exists(`auditActions.${action}`) ? t(`auditActions.${action}`) : action);
}
